module.exports = __webpack_public_path__ + "img/SES_235415100.a2a8e972.jpg";